import { AxiosInstance } from "axios";

import { DeskpassResponse } from "repository/deskpass/types/meta";

const createSignupEmailVerificationRepository = (client: AxiosInstance) => {
  return {
    sendSignupEmailVerification: () => {
      return client.post<DeskpassResponse<null>>(
        "/api/team-managers/signup-email-verification/send"
      );
    },
    verifySignupEmail: (hash: string) => {
      return client.get<DeskpassResponse<{ alreadyVerified: boolean }>>(
        `/api/team-managers/signup-email-verification/confirm/${hash}`
      );
    },
  };
};

export default createSignupEmailVerificationRepository;
